<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'80%'">
    <v-card v-if="itemDetail">
      <v-card-title>{{title}}</v-card-title>
      <v-card-text>
        <v-tabs class="mb-2"
                v-model="tab"
                :color="Theme.GREEN">
          <v-tab :value="0">訂單資訊</v-tab>
          <v-tab :value="1">訂單商品資訊</v-tab>
          <v-tab :value="2">訂單評分資訊</v-tab>
<!--          <v-tab :value="2" v-if="itemDetail.paymentType === 3">AFTEE訂單明細</v-tab>-->
        </v-tabs>
        <div v-if="tab === 0">
          <v-layout>
            <v-flex>
              <v-stepper
                  v-model="orderStep"
                  alt-labels
                  class="mt-12"
                  :color="Theme.GREEN"
              >
                <v-stepper-header>
                  <v-stepper-step step="1"
                                  :color="Theme.GREEN"
                                  :complete="orderStep >= 1">
                    未付款
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2"
                                  :color="Theme.GREEN"
                                  :complete="orderStep >= 2">
                    已付款
<!--                    <small>{{ itemDetail.paymentStatus === 1 ? itemDetail.paymentDate  :'' }}</small>-->
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="3"
                                  :color="Theme.GREEN"
                                  :complete="orderStep >= 3">
                    待出貨
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="4"
                                  :color="Theme.GREEN"
                                  :complete="orderStep >= 4">
                    已出貨
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="5"
                                  :color="Theme.GREEN"
                                  :complete="orderStep >= 5">
                    已完成
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-flex>
          </v-layout>

          <v-card class="mt-2">
            <v-card-text>
              <v-layout v-for="col in getDialogKeys" :key="col.value">
                <v-flex>
                  <!--              <v-textarea v-if="col.value === 'comment'" :label="col.text" :color="Theme.GREEN"-->
                  <!--                          v-model="itemDetail[col.value]"/>-->
                  <div v-if="col.tag" class="mt-1">
                    <label class="subtitle-2" style="color: black;">{{ `${col.text} : ` }}</label>
                    <v-chip :dark="getSelectColor(col, itemDetail) !== Theme.LIGHT_GRAY"
                            :color="getSelectColor(col, itemDetail)">{{ getSelectList(col, itemDetail) }}</v-chip>
                  </div>

                  <div v-else-if="col.value === 'vendorId'">
                    <v-select
                        class="mt-1 col-sm-12 col-md-2"
                        :color="Theme.GREEN"
                        :items="col.options"
                        :label="col.text"
                        item-text="name" item-value="vendorId"
                        v-model="itemDetail.vendorId"/>
                  </div>

                  <v-select v-else-if="col.options && col.value !== 'vendorId'"
                            class="mt-1 col-sm-12 col-md-2"
                            :color="Theme.GREEN"
                            :items="col.options"
                            :label="col.text"
                            item-text="value" item-value="key"
                            v-model="itemDetail[col.key]"/>

                  <div v-else-if="col.disable" class="mt-1">
                    <label class="subtitle-2" style="color: black;">{{ `${col.text} : ` }}</label>
                    <span class="subtitle-1" :style="{ color: Theme.GREEN }">{{itemDetail[col.value]}}</span>
                  </div>

                  <div v-else-if="col.value === 'city'
                  && (itemDetail.shippingType === 'POST' || itemDetail.shippingType === 'POST-out'
                  || itemDetail.shippingType === 'PICKUP')" class="mt-1">
                    <v-layout column>
                            <v-flex >
                              <v-layout md6>
                                <v-flex>
                                  <v-autocomplete
                                      :color="Theme.GREEN"
                                      :items="cityList"
                                      placeholder="縣市"
                                      :disabled="isCancel || isVendor"
                                      v-model="itemDetail.city"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex>
                                  <v-autocomplete :color="Theme.GREEN"
                                                  :items="areaList[itemDetail.city] ? areaList[itemDetail.city] : []"
                                                  placeholder="鄉鎮區"
                                                  :disabled="!itemDetail.city || itemDetail.city === '' || isCancel || isVendor"
                                                  v-model="itemDetail.district"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex>
                                  <v-text-field class="mt-1" v-model="itemDetail.zipCode"
                                                :label="`郵遞區號 : `"
                                                disabled
                                                :color="Theme.GREEN"></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex>
                              <v-text-field class="mt-1" v-model="itemDetail.address"
                                            :label="`地址 : `"
                                            :disabled="isCancel  || isVendor"
                                            :color="Theme.GREEN"></v-text-field>
                            </v-flex>
                            <v-flex>
                              <v-text-field class="mt-1" v-model="itemDetail.shippingNumber"
                                            :label="`物流單號 : `"
                                            :disabled="isCancel"
                                            :color="Theme.GREEN"></v-text-field>
                            </v-flex>
                      </v-layout>
                  </div>

                  <div v-else-if="col.value === 'store'
                  && (itemDetail.shippingType === 'UNIMARTC2C'
                  || itemDetail.shippingType === 'FAMIC2C'
                  || itemDetail.shippingType === 'HILIFEC2C'
                  || itemDetail.shippingType === 'OKMARTC2C')" class="mt-1">
                    <v-layout column>
                      <v-flex>
                        <label class="subtitle-1" style="color: black;">門市類型 : </label>
                        <span class="subtitle-1" :style="{ color: Theme.GREEN }">{{ findStoreType(itemDetail.storeType) }}</span>
                      </v-flex>
                      <v-flex>
                        <label class="subtitle-1" style="color: black;">門市代號 : </label>
                        <span class="subtitle-1" :style="{ color: Theme.GREEN }">{{itemDetail.storeId}}</span>
                      </v-flex>
                      <v-flex>
                        <label class="subtitle-1" style="color: black;">門市名稱 : </label>
                        <span class="subtitle-1" :style="{ color: Theme.GREEN }">{{itemDetail.storeName}}</span>
                      </v-flex>
<!--                      <v-flex v-if="itemDetail.storeId">-->
<!--                        <label v-if="itemDetail.shippingNumber" class="subtitle-1" style="color: black;">物流單號 : </label>-->
<!--                        <span  class="subtitle-1" v-if="itemDetail.shippingNumber" :style="{ color: Theme.GREEN }">-->
<!--                          {{ `${itemDetail.shippingNumber}${itemDetail.shippingCode ? itemDetail.shippingCode : ''}` }}</span>-->
<!--                        <v-btn dark :color="Theme.GREEN" v-else-->
<!--                               :disabled="isCancel"-->
<!--                               @click="createShippingNumber">產生物流單號</v-btn>-->
<!--                      </v-flex>-->
                    </v-layout>
                  </div>

                  <div v-else-if="col.value === 'fullAddress' && (itemDetail.shippingType === 'POST' || itemDetail.shippingType === 'POST-out')" class="mt-1">
                    <v-layout column>
                      <v-flex>
                        <v-text-field class="mt-1" v-model="itemDetail.fullAddress"
                                      :label="col.text"
                                      :disabled="isCancel || col.disable"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
<!--                      <v-flex>-->
<!--                        <v-text-field class="mt-1" v-model="itemDetail.shippingNumber"-->
<!--                                      :label="`物流單號 : `"-->
<!--                                      :disabled="isCancel || col.disable"-->
<!--                                      :color="Theme.GREEN"></v-text-field>-->
<!--                      </v-flex>-->
                    </v-layout>
                  </div>

                  <div v-else-if="col.value === 'name'" class="mt-1">
                    <v-row no-gutters>
                      <v-col cols="8">
                        <v-text-field v-model="itemDetail[col.value]"
                                      :label="col.text"
                                      :disabled="col.disable"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-col>
                      <v-col cols="4" class="pl-3 d-flex align-center">
                        <v-btn dark 
                               :color="Theme.ORANGE" 
                               :disabled="col.disable || !itemDetail.email"
                               @click="sendConfirmationEmail">
                          寄信確認
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>

                  <v-text-field class="mt-1" v-else v-model="itemDetail[col.value]"
                                :label="col.text"
                                :disabled="col.disable"
                                :color="Theme.GREEN"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn dark :color="Theme.GREEN" :loading="saveLoading" :disabled="cancelLoading"
                     v-if="!isCancel"
                     @click="confirmEvent">儲存</v-btn>

              <v-spacer></v-spacer>


              <v-btn dark :color="Theme.ORANGE" :loading="changeLoading" class="ml-1" v-if="isAdmin && itemDetail.paymentType === 1 && itemDetail.paymentStatus === 0"
                     @click="changeOrderPaymentStatus(1)">訂單已匯款</v-btn>

              <div>
                <v-btn dark :color="Theme.ORANGE" :loading="changeLoading" class="ml-1" v-if="isAdmin || isStaff"
                       @click="createShippingInfoEvent()">建立出貨單</v-btn>

                <v-btn dark :color="Theme.ORANGE" :loading="changeLoading" class="ml-1" v-if="orderStep === 2"
                       @click="changeOrderStatus(5)">備貨中</v-btn>

                <!-- todo 檢查是否存在物流單號 -->
                <v-btn :color="Theme.GARY" :loading="changeLoading" class="ml-1" v-if="orderStep === 3 && showShippingButton" disabled>請填寫物流單號再出貨</v-btn>
                <v-btn dark :color="Theme.GREEN" :loading="changeLoading" class="ml-1" v-else-if="orderStep === 3"
                       @click="changeOrderStatus(1)">訂單出貨</v-btn>
                
                <!-- * 若訂單為備貨中 & 自取 顯示 > 通知客人取貨 -->
                <v-btn dark :color="Theme.GREEN" :loading="changeLoading" class="ml-1" v-if="orderStep === 3 && itemDetail.shippingType === 'PICKUP'"
                @click="completePickupOrderEvent()">通知客人自取</v-btn>

                <v-btn dark :color="Theme.GREEN" :loading="changeLoading" class="ml-1" v-if="orderStep === 4"
                       @click="changeOrderStatus(2)">訂單完成</v-btn>
                <v-btn dark :color="Theme.RED" :loading="changeLoading" class="ml-1" v-if="orderStep >=3"
                       @click="changeOrderStatus(3)">訂單退貨/取消</v-btn>
                <v-btn dark :color="Theme.ORANGE" :loading="changeLoading" class="ml-1" v-if="orderStep >=3"
                       @click="changeOrderStatus(3)">訂單未取貨</v-btn>
              </div>

              <v-btn dark :color="Theme.RED" :loading="changeLoading" class="ml-1"
                     v-if="(isAdmin || isStaff) && itemDetail.paymentStatus === 0"
                     @click="changeOrderStatus(3)">訂單取消</v-btn>

              <v-btn dark :color="Theme.ORANGE" :loading="changeLoading" class="ml-1" v-if="itemDetail.paymentType !== 3 && itemDetail.paymentStatus === 1"
                     @click="changeOrderPaymentStatus(2)">訂單退款中</v-btn>

              <v-btn dark :color="Theme.RED" :loading="changeLoading" class="ml-1" v-if="itemDetail.paymentType === 3 || itemDetail.paymentStatus === 2"
                     @click="changeOrderPaymentStatus(3)">訂單已退款</v-btn>

<!--              <v-btn dark :color="Theme.RED" :loading="cancelLoading" v-if="itemDetail.shippingStatus !== 2 &&-->
<!--              itemDetail.paymentType === 3 && itemDetail.paymentStatus === 1"-->
<!--                     @click="afteeCancelEvent">AFTEE 取消訂單</v-btn>-->

            </v-card-actions>
          </v-card>

        </div>
        <v-layout class="mt-2" v-if="tab === 1" row>
          <v-flex>
            <v-data-table
                :headers="getColumnKeys"
                :items="itemDetail.carts"
                :items-per-page="itemDetail.carts.length"
                hide-default-footer>
              <template v-slot:header.name="{ header }">
                {{ header.text }}
              </template>
              <template v-slot:body="{ items }">
                <tbody>
                <tr v-for="(item, i) in items" :key="i">
                  <td v-for="col in getColumnKeys" :key="col.value">
                    <img v-if="col.value === 'imageUrl'" :src="item[col.value]" height="80">
                    <span v-else>{{item[col.value]}}</span>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout class="mt-2" v-if="tab === 2" row>
          <v-flex>
            <p>評分： <b>{{ itemDetail.rate }}</b></p>
            <p>評分時間：<b> {{ itemDetail.rateDate }}</b></p>
            <p>買家評語：<b> {{ itemDetail.rateComment }}</b></p>
<!--            <aftee-detail :info="afteeDetailData"/>-->
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent">關閉</v-btn>
<!--        <v-btn dark :color="Theme.GREEN" :loading="saveLoading" :disabled="cancelLoading" @click="confirmEvent">儲存</v-btn>-->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "OrderDetail",
  components: {},
  mixins: [common],
  props: {
    title:String,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      cityData: require('@/assets/json/taiwan_city.json'),
      cityList: [],
      areaList: {},
      orderStep: 3,
      saleStartDateMenu: false,
      saleEndDateMenu: false,
      saveLoading: false,
      confirmLoading: false,
      cancelLoading: false,
      changeLoading: false,
      loading: false,
      content: '',
      editorOption: {
        placeholder:'商品詳細介紹'
      },
      tab: 0,
      defaultImageItem: {
        productId:'',
        url:'',
        sort:0,
      },
      defaultLinkItem: {
        productId:'',
        title:'',
        url:'',
        createdDate: new Date(),
      },
      typeList:[],
      subtypeList: {},
      selectSubtypeList:[],
      selectType:'',
      selectSubType:'',
      afteeDetailData: null,
      vendorList:[],
      selectVendor: '',
      showShippingButton: false, // 出貨按鈕
    };
  },
  watch:{
    // tab(value){
    //   if (value === 2 || value === '2'){
    //     this.loadAfteeData();
    //   }
    // },
    visible(value){
      if (value){
        this.loadVendorList();
        this.checkOrderStep();
        this.loadCityData();
      }
    },
    'itemDetail.shippingSearchCode': function(newVal, oldVal) {
      this.showShippingButton =!newVal; // 有物流單號就不顯示
      console.log(`shippingSearchCode ${oldVal} ${newVal} ${this.showShippingButton}`);
    }
  },
  created() {
    this.checkOrderStep();
    this.loadCityData();
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    getDialogKeys() {
      let list;
      if (this.isVendor){
         list = [
          {value: 'displayId', text: '訂單編號' ,disable: true},
          { value:'createdDate', text:'日期', sortable: true ,disable: true},
          { value:'name', text:'收件人', sortable: false ,disable: true},
          { value:'email', text:'收件人Email', sortable: false ,disable: true},
          { value:'cellphone', text:'收件電話', sortable: false ,disable: true},
          { value:'shippingType', text:'寄送方式', sortable: true , options: this.getStoreType, tag: true , disable: true},
          { value:'city', text:'地址', sortable: true },
          { value:'fullAddress', text:'收件地址', sortable: false ,disable: true},
          { value:'store', text:'門市', sortable: true ,disable: true},
          { value:'shippingStatus', text:'運送狀態', sortable: false , options: this.getOrderStatus, tag: true ,disable: true },
          // { value:'paymentType', text:'付款方式', sortable: false , options: this.getPaymentType, tag: true ,disable: true},
          // { value:'paymentDate', text:'付款日期', sortable: false , disable: true},
          { value:'shippingPrice', text:'運費', sortable: false ,disable: true},
          { value:'amount', text:'總金額', sortable: true ,disable: true },
           { value:'shippingSearchCode', text:'物流單號', sortable: this.isCancel},
          { value:'comment', text: '備註' , disable: true},
        ];
      } else {
        list = [
          {value: 'orderId', text: '系統編號' ,disable: true},
          {value: 'displayId', text: '訂單編號' ,disable: true},
          { value:'createdDate', text:'日期', sortable: true ,disable: true},
          { value:'vendorId', text:'供應商', sortable: false , options: this.vendorList, tag: false ,disable: true },
          { value:'name', text:'收件人', sortable: false ,disable: this.isCancel },
          { value:'email', text:'收件人Email', sortable: false ,disable: true},
          { value:'cellphone', text:'收件電話', sortable: false ,disable: this.isCancel},
          { value:'shippingType', text:'寄送方式', sortable: true , options: this.getStoreType, tag: true , disable: true},
          { value:'city', text:'地址', sortable: true },
          { value:'fullAddress', text:'收件地址', sortable: false , disable: this.isCancel},
          { value:'store', text:'門市', sortable: true },
          { value:'shippingStatus', text:'運送狀態', sortable: false , options: this.getOrderStatus, tag: true ,disable: true },
          { value:'paymentType', text:'付款方式', sortable: false , options: this.getPaymentType, tag: true ,disable: true},
          { value:'shippingPrice', text:'運費', sortable: false ,disable: true},
          { value:'amount', text:'總金額', sortable: true ,disable: true },
          { value:'shippingSearchCode', text:'物流單號', sortable: false , disable: this.isCancel},
          { value:'comment', text: '備註' , disable: true},
          { value:'helperComment', text: '小幫手備註' ,sortable: false , disable: this.isCancel},
        ];
      }
      if (this.itemDetail.shippingType === 'UNIMARTC2C' || this.itemDetail.shippingType === 'FAMIC2C'
      || this.itemDetail.shippingType === 'HILIFEC2C' || this.itemDetail.shippingType === 'OKMARTC2C'){
        return list.filter(i=>i.value !== 'city' && i.value !== 'fullAddress');
      } else if (this.itemDetail.shippingType === 'POST' || this.itemDetail.shippingType === 'POST-out'){
        return list.filter(i=>i.value !== 'store' && i.value !== 'fullAddress');
      } else if (this.itemDetail.shippingType === 'POST-international'){
        return list.filter(i=>i.value !== 'store' && i.value !== 'city');
      } else {
        return list;
      }
    },
    getColumnKeys(){
      return [
        { value:'categoryId', text:'商品編號', sortable: true },
        { value:'imageUrl', text:'圖片', sortable: true },
        { value:'productName', text:'商品名稱', sortable: true },
        { value:'name', text:'賞品名稱', sortable: true },
        { value:'vendorName', text:'供應商', sortable: true },
        { value:'category', text:'類別', sortable: true },
        { value:'weight', text:'體積', sortable: true },
      ]
    },
    isCancel(){
      return this.itemDetail.paymentStatus === 2 || this.itemDetail.paymentStatus === 3;
    }
  },
  methods:{
    ...mapActions(['updateOrderInfo', 'createShippingOrder', 'sendShippingOrder', 'afteeCancel', 'afteeDetail','afteeConfirm'
    ,'updateOrderStatus', 'updateOrderPaymentStatus','createShippingInfo', 'getVendorList', 'completePickupOrder', 'confirmNotify']),
    async loadVendorList(){
      try {
        const res = await this.getVendorList();
        const result = res.data;
        if (result.statusCode === 0){
          this.vendorList = result.data;
          console.log(`loadVendorList `, JSON.stringify( this.vendorList));
          this.$forceUpdate();
        }
      } catch (e) {
        console.log(`getVendorList error `, e);
      }
    },
    loadCityData(){
      this.cityData.taiwan.forEach((city) => {
        this.cityList.push(city.city);
        this.areaList[city.city] = city.area;
      });
    },
    checkOrderStep(){
      if (this.itemDetail){


        if (this.itemDetail.paymentStatus === 1){
          this.orderStep = 3;
        }

        if (this.itemDetail.shippingStatus === 0){
          this.orderStep = 2;
        } else if (this.itemDetail.shippingStatus === 1){
          this.orderStep = 4;
        } else if (this.itemDetail.shippingStatus === 2){
          this.orderStep = 5;
        } else if (this.itemDetail.shippingStatus === 5){
          this.orderStep = 3;
        }
      }
    },
    async loadAfteeData(){
      try {
        this.loading = true;
        const res = await this.afteeDetail( { orderId: this.itemDetail.orderId } );
        const result = res.data;

        if (res.status === 200 && result.statusCode === 0) {
          console.log(`loadAfteeData ${JSON.stringify(result)}`);
          this.afteeDetailData = result.data;
        } else {
          this.showMessageDialog('錯誤', result.message ? result.message : '取消失敗');
        }
      } catch (e) {
        console.log(`res error ${JSON.stringify(e)}`);
        this.showMessageDialog('錯誤', '失敗');
      }
      this.loading = false;
    },
    getSelectList(col, option){
      console.log(`getSelectList === ${option[col.value]}`);
      const find = col.options.find(item=>item.key === option[col.value]);
      if (find){
        return find.value;
      }
      return '--'
    },
    getSelectColor(col, option){
      console.log(`getSelectList === ${option[col.value]}`);
      const find = col.options.find(item=>item.key === option[col.value]);
      if (find){
        return find.color;
      }
      return this.Theme.LIGHT_GRAY
    },
    cancelEvent() {
      this.$emit('cancelEvent');
    },
    async confirmEvent() {
      this.saveLoading = true;

      try {
        this.itemDetail.country = 'zh-TW';
        console.log(`save ${JSON.stringify(this.itemDetail)}`);
        const res = await this.updateOrderInfo( this.itemDetail );
        const result = res.data;
        console.log(`res ${JSON.stringify(result)}`);
        if (res.status === 200 && result.statusCode === 0) {
          this.$emit('confirmEvent', this.itemDetail);
        } else {
          this.showMessageDialog('錯誤', result.message ? result.message : '儲存失敗');
        }

      } catch (e) {
        console.log(`res error ${JSON.stringify(e)}`);
        this.showMessageDialog('錯誤', '儲存失敗');
      }
      this.saveLoading = false;
    },
    async afteeConfirmEvent(){
      try {
        this.confirmLoading = true;
        const res = await this.afteeConfirm( { orderId: this.itemDetail.orderId } );
        const result = res.data;
        console.log(`afteeConfirm ${JSON.stringify(result)}`);
        if (res.status === 200 && result.statusCode === 0) {
          this.showAlert({
            title: '提示',
            content: result.message,
            showCancel: false,
            confirmEvent: async () => {
              this.hideAlert();
              this.$emit('reloadEvent');
            }
          });
        } else {
          this.showMessageDialog('錯誤', result.message ? result.message : '失敗');
        }

      } catch (e) {
        console.log(`res error ${JSON.stringify(e)}`);
        this.showMessageDialog('錯誤', '失敗');
      }
      this.confirmLoading = false;
    },
    async afteeCancelEvent(){
      try {
        this.cancelLoading = true;
        const res = await this.afteeCancel( { orderId: this.itemDetail.orderId } );
        const result = res.data;
        console.log(`afteeCancelEvent ${JSON.stringify(result)}`);
        if (res.status === 200 && result.statusCode === 0) {
          this.showAlert({
            title: '提示',
            content: result.message,
            showCancel: false,
            confirmEvent: async () => {
              this.hideAlert();
              this.$emit('reloadEvent');
            }
          });
        } else {
          this.showMessageDialog('錯誤', result.message ? result.message : '取消失敗');
        }

      } catch (e) {
        console.log(`res error ${JSON.stringify(e)}`);
        this.showMessageDialog('錯誤', '失敗');
      }
      this.cancelLoading = false;
    },
    showMessageDialog(title, content) {
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
    async createShippingInfoEvent(){
      try {
        this.changeLoading = true;
        const res = await this.createShippingInfo({ orderId: this.itemDetail.orderId } );
        const result = res.data;
        if (res.status === 200 && result.statusCode === 0) {
          const info = result.data;
          console.log(`createShippingInfo ${JSON.stringify(info)}`);
          this.showMessageDialog('成功', result.message);
        } else {
          this.showMessageDialog('錯誤', `${result.message} ${result.data}`);
        }

      } catch (e) {
        console.log(`res error ${JSON.stringify(e)}`);
        this.showMessageDialog('錯誤', '失敗');
      } finally {
        this.changeLoading = false;
      }
    },
    async createShippingNumber(){
      try {
        const res = await this.createShippingOrder({ orderId: this.itemDetail.orderId } );
        const result = res.data;
        if (res.status === 200 && result.statusCode === 0) {
          const info = result.data;
          console.log(`createShippingNumber ${JSON.stringify(info)}`);
          this.showMessageDialog('成功', result.message);
        } else {
          this.showMessageDialog('錯誤', `${result.message} ${result.data}`);
        }

      } catch (e) {
        console.log(`res error ${JSON.stringify(e)}`);
        this.showMessageDialog('錯誤', '失敗');
      }
    },
    async changeOrderStatus(shippingStatus){
      try {
        this.changeLoading = true;
        let updateParams = {
          orderId: this.itemDetail.orderId,
          shippingStatus: shippingStatus,
        };

        // 根據條件添加 shippingSearchCode
        if (shippingStatus === 1) {
          updateParams.shippingSearchCode = this.itemDetail.shippingSearchCode;
        }

        const res = await this.updateOrderStatus(updateParams);
        // const res = await this.updateOrderStatus({
        //   orderId: this.itemDetail.orderId,
        //   shippingStatus: shippingStatus
        // });
        const result = res.data;
        this.changeLoading = false;
        if (res.status === 200 && result.statusCode === 0) {
          this.showAlert({
            title: '提示',
            content: result.message,
            showCancel: false,
            confirmEvent: async () => {
              this.hideAlert();
              this.$emit('reloadEvent');
              this.$emit('cancelEvent');
            }
          });
        } else {
          this.showMessageDialog('錯誤', `${result.message} ${result.data}`);
        }
      } catch (e) {
        this.changeLoading = false;
        console.log(`res error ${JSON.stringify(e)}`);
        this.showMessageDialog('錯誤', '失敗');
      }
    },
    async changeOrderPaymentStatus(paymentStatus){
      try {
        this.changeLoading = true;
        const res = await this.updateOrderPaymentStatus({
          orderId: this.itemDetail.orderId,
          paymentStatus: paymentStatus
        });
        const result = res.data;
        this.changeLoading = false;
        if (res.status === 200 && result.statusCode === 0) {
          this.showAlert({
            title: '提示',
            content: result.message,
            showCancel: false,
            confirmEvent: async () => {
              this.hideAlert();
              this.$emit('reloadEvent');
              this.$emit('cancelEvent');
            }
          });
        } else {
          this.showMessageDialog('錯誤', `${result.message} ${result.data}`);
        }
      } catch (e) {
        this.changeLoading = false;
        console.log(`res error ${JSON.stringify(e)}`);
        this.showMessageDialog('錯誤', '失敗');
      }
    },
    async completePickupOrderEvent(){
      try {
        const res = await this.completePickupOrder({ orderId: this.itemDetail.orderId } );
        const result = res.data;
        if (res.status === 200 && result.statusCode === 0) {
          this.showMessageDialog('成功', result.message);
        } else {
          this.showMessageDialog('錯誤', `${result.message} ${result.data}`);
        }
      } catch (e) {
        console.log(`res error ${JSON.stringify(e)}`);
        this.showMessageDialog('錯誤', '失敗');
      }
    },
    sendConfirmationEmail() {
      // 實作寄信確認收件姓名的邏輯
      console.log('寄送確認信件給:', this.itemDetail.email);
      console.log('確認收件人:', this.itemDetail.name);
      
      // 顯示確認對話框
      this.showAlert({
        title: '確認',
        content: `確定要寄送確認信件給 ${this.itemDetail.name} 嗎？`,
        showCancel: true,
        confirmEvent: async () => {
          this.hideAlert();
          try {
            const res = await this.confirmNotify({ orderId: this.itemDetail.orderId } );
            const result = res.data;
            if (res.status === 200 && result.statusCode === 0) {
              this.showMessageDialog('成功', result.message);
            } else {
              this.showMessageDialog('錯誤', `${result.message} ${result.data}`);
            }
            this.showMessageDialog('成功', '確認信件已寄出');
          } catch (e) {
            console.log('寄送確認信件失敗:', e);
            this.showMessageDialog('錯誤', '寄送確認信件失敗');
          }
        },
        cancelEvent: () => {
          this.hideAlert();
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
